import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Text,
  UseDisclosureReturn,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { resetAccount } from "../../api/account/resetAccount";
import { ConfirmActionModal } from "../../components/modals/ConfirmActionModal";
import {
  getAccountTransactionsCacheKey,
  queryClient,
  resetTransactionStore,
} from "../../store/transactionsStore";
import { Account } from "../../types/Account";

export function ResetAccountModal({
  account,
  disclosure,
}: {
  account: Account;
  disclosure: UseDisclosureReturn;
}): React.ReactElement {
  const onConfirm = async () => {
    await resetAccount(account._id);

    resetTransactionStore({ initAccountId: account._id });

    queryClient.invalidateQueries([
      ...getAccountTransactionsCacheKey(account._id),
    ]);
  };

  return (
    <ConfirmActionModal
      title="Reset account?"
      confirmButtonText="Reset account"
      successTitle="Account successfully reset"
      colorScheme="red"
      disclosure={disclosure}
      onConfirm={onConfirm}
    >
      <Text mb={6}>
        You are resetting the account{" "}
        <Text as="span" fontWeight="bold">
          {account.fullName}
        </Text>{" "}
        {`back to it's initial state.`}
      </Text>
      <Alert status="error" borderRadius="md" alignItems="flex-start">
        <AlertIcon />
        <VStack align="flex-start" spacing={2}>
          <AlertTitle>This action cannot be undone.</AlertTitle>
          <AlertDescription>
            This will permanently remove all data sources, transactions, and
            reset other account data.
          </AlertDescription>
        </VStack>
      </Alert>
    </ConfirmActionModal>
  );
}
